
export default function Expertise() {
  const skills = [
    {
      icon: 'ri-bar-chart-grouped-line',
      title: 'Strat\u00e9gie Digitale',
      items: [
        'Audit & diagnostic digital',
        'Roadmap de transformation',
        'Business models num\u00e9riques',
        'Go-to-market digital',
      ],
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'E-commerce & Acquisition',
      items: [
        'Tunnels de vente optimis\u00e9s',
        'SEO & r\u00e9f\u00e9rencement',
        'Publicit\u00e9 Meta & Google Ads',
        'Conversion & A/B testing',
      ],
    },
    {
      icon: 'ri-robot-line',
      title: 'Automatisation & CRM',
      items: [
        'Marketing automation',
        'Relances WhatsApp & email',
        'Lead scoring & qualification',
        'Int\u00e9gration d\u2019outils',
      ],
    },
    {
      icon: 'ri-team-line',
      title: 'Conseil & Accompagnement',
      items: [
        'Accompagnement dirigeants',
        'Conduite du changement',
        'Formation des \u00e9quipes',
        'Pilotage de la performance',
      ],
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-white overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Ce que j\u2019apporte \u00e0 <strong className="text-orange-600">votre business</strong>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Une approche compl\u00e8te qui couvre toute la cha\u00eene de valeur digitale, de la strat\u00e9gie \u00e0 l\u2019ex\u00e9cution
          </p>
        </header>

        {/* Skills grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {skills.map((skill, i) => (
            <article
              key={i}
              className="group bg-white rounded-2xl p-6 shadow-lg border border-gray-100 hover:border-orange-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${skill.icon} text-xl text-white`} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-4">
                {skill.title}
              </h3>
              <ul className="space-y-2.5">
                {skill.items.map((item, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2 text-sm text-gray-600"
                  >
                    <i className="ri-check-line text-orange-500 mt-0.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
